import { Outlet } from 'react-router-dom'

export default function SsoLayout() {
  return (
    <div className="helix-d-flex helix-align--center helix-justify--center helix-py-7 helix-px-sm-4 min-h-[100dvh]">
      <Outlet />
    </div>
  )
}
